import type { Control } from "react-hook-form";
import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { BuildingFormFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingFormFields";
import { getBuildingDescriptionLabel } from "web_myplann/Portfolio/Forms/BuildingShared/buildingDescriptionLabel";
import type {
	HouseFormInput,
	HouseFormOutput,
} from "web_myplann/Portfolio/Forms/HouseForm/houseFormSchema";

type HouseFormFieldsProps = {
	control: Control<HouseFormInput, unknown, HouseFormOutput>;
};

export const HouseFormFields = ({ control }: HouseFormFieldsProps) => {
	const { t } = useResource();

	return (
		<BuildingFormFields
			control={control}
			descriptionLabel={getBuildingDescriptionLabel(
				t,
				ClientPropertyTypeEnum.House,
			)}
		/>
	);
};
